<template>
  <div class="login-page">
    <div class="form">
      <img src="../assets/logo.png" class="logo">
      <form>
        <v-text-field
          v-validate="'required'"
          v-model="username"
          :error-messages="errors.collect('username')"
          :label="$t('authentication.Username')"
          data-vv-name="username"
          required
        ></v-text-field>
        <v-text-field
          type="password"
          v-validate="'required'"
          v-model="password"
          :error-messages="errors.collect('password')"
          :label="$t('authentication.Password')"
          data-vv-name="password"
          required
        ></v-text-field>
        <div class="buttons">
          <v-btn @click="submit" color="primary">{{$t("authentication.Login")}}</v-btn>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

export default {
  $_veeValidate: {
    validator: "new"
  },

  data: () => ({
    username: "",
    password: "",
    dictionary: {
      custom: {}
    }
  }),

  created() {
    this.dictionary.custom.username = {
      required: () => this.$t("authentication.UsernameCanNotBeEmpty")
    };
    this.dictionary.custom.password = {
      required: () => this.$t("authentication.PasswordCanNotBeEmpty")
    };
    this.$validator.localize("ar", this.dictionary);
  },
  notifications: {
    showLoginError: {
      message: "Failed To Authenticate",
      type: "error"
    },
    showLoginSuccess: {
      message: "Failed To Authenticate",
      type: "success"
    }
  },
  methods: {
    submit() {
      this.$validator
        .validateAll()
        .then(valid => {
          if (valid) {
            this.$api.login(this.username, this.password).then(response => {
              if (!response.error) {
                if (response.list.user.typeLabel === "Expert") {
                  this.showLoginSuccess({message: this.$t("authentication.SuccessLogin")});
                  this.$store.dispatch("login", { user: response.list.user });
                } else {
                  this.showLoginError({ message: this.$t("authentication.OnlyExpertCanLogin") });
                }
              } else {
                this.showLoginError({ message: response.message });
              }
            });
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style lang="scss">
.login-page {
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  > .form {
    max-width: 500px;
    width: 100%;
    .logo {
      display: block;
      margin: 15px auto;
      max-width: 200px;
    }
    form {
      background: #fff;
      padding: 30px;
      border-radius: 2px;
      box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
        0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
      .buttons {
        text-align: center;
        font-size: 22px;
      }
      .v-text-field {
        font-size: 22px;
      }
    }
  }
}
</style>

